import "styles/paywall/refund.less";
import { FC, useContext } from "react";

import { AppContext } from "App";
import wallet from "assets/images/new-questionnaire/expenses/wallet.svg";
import { formatAmountWithCommas } from "utils/new-questionnaire";

interface RefundProps {
    refundAmount: number;
}

export const Refund: FC<RefundProps> = ({ refundAmount }: RefundProps) => {
    const { isMobile } = useContext(AppContext);
    return (
        <div className="refund">
            <div className="refund__content">
                <div className="refund__title">
                Your Estimated Refund
                </div>
                <div className="refund__amount">
                    {`£${formatAmountWithCommas(refundAmount.toFixed(2))}`}
                </div>
                <div className="refund__description">
                Based on your current information
                </div>
            </div>
            {!isMobile && <div className="refund__image-container" >
                <img className="refund__image" src={wallet} alt="wallet"/>
            </div>}
        </div>
    );
};
